import getWithToken from './base/get-with-token'

const getWaterUsage = getWithToken(`/report/water-usage`)

export default getWaterUsage
